import React from 'react';
import Typer from 'components/Typer';
import Button from 'components/deprecated/legacyElements/Button';
import H2 from 'components/deprecated/legacyElements/H2';
import Link from 'components/links/Unstyled/Internal';
import styles from './style.module.scss';

const WelcomeSection = () => (
  <div className={styles.hideOverflowWrapper}>
    <div className={`inset ${styles.welcomeWrapper}`}>
      <picture className={styles.welcomeHeroImage}>
        <source type="image/webp" srcSet={require('./hero.webp')} />
        <img
          src={require('./hero.png')}
          loading="lazy"
          alt="A conference room table with chairs"
        />
      </picture>
      <div className={styles.welcomeHeaderContent}>
        <H2 className={styles.welcomeHeader}>
          SquareFoot.
          <br />
          <div className={styles.typedText}>
            <Typer text="The new way to find office space." />
          </div>
        </H2>
        <Link to="/profile/size">
          <Button className={styles.welcomeButton}>Get Started</Button>
        </Link>
      </div>
    </div>
  </div>
);

export default WelcomeSection;
